import {
  POST_ORDER_START,
  POST_ORDER_SUCCESS,
  POST_ORDER_FAIL,
  GET_ORDERS_START,
  GET_ORDERS_SUCCESS,
  CANCEL_ORDER_FAIL,
  CANCEL_ORDER_SUCCESS,
  CANCEL_ORDER_START,
  UPDATE_ORDER_PARAMS,
  REFETCH_ORDERS,
  UPDATE_ORDER_VIA_SOCKET
} from './actionTypes'

export const makeOrder = (payload) => {
  return {
    type: POST_ORDER_START,
    payload,
  }
}

export const postOrderSuccess = (params = {}) => {
  return {
    type: POST_ORDER_SUCCESS,
    payload: params,
  }
}
export const postOrderFail = (params = {}) => {
  return {
    type: POST_ORDER_FAIL,
    payload: params,
  }
}
export const getOrdersStart = (params) => {
  return {
    type: GET_ORDERS_START,
    payload: params,
  }
}
export const getOrdersSuccess = (data) => {
  return {
    type: GET_ORDERS_SUCCESS,
    payload: data,
  }
}


// Add to actions.js
export const cancelOrderStart = (orderId) => {
  console.log("cancelOrderStart actions.js", orderId)
  return {
    type: CANCEL_ORDER_START,
    payload: {
      orderId,
    },
  }
}

export const cancelOrderSuccess = (orderId) => {
  return {
    type: CANCEL_ORDER_SUCCESS,
    payload: orderId,
  }
}

export const cancelOrderFail = (error) => {
  return {
    type: CANCEL_ORDER_FAIL,
    payload: error,
  }
}

// Order parameters actions
export const updateOrderParams = (params) => {
  return {
    type: UPDATE_ORDER_PARAMS,
    payload: params
  }
}

export const refetchOrders = () => {
  return {
    type: REFETCH_ORDERS
  }
}

/**
 * Action to update an order via socket event
 * @param {Object} order - The updated order object from socket
 */
export const updateOrderViaSocket = (order) => ({
  type: UPDATE_ORDER_VIA_SOCKET,
  payload: order
})